import React from 'react';
import { FaInstagram, FaLinkedin, FaFacebook } from 'react-icons/fa'; // Import social media icons

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-5 border-t-2 border-blue-600">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-lg font-semibold">This Death Predictor is made by <a href='https://webmafiya.com/' className='text-blue-600 font-extrabold'> WebMafiya</a></p>
        <div className="flex justify-center space-x-5 my-4">
          <a href="https://www.instagram.com/webmafiya?igsh=djJocHo5eXFuZHU1" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FaInstagram className="text-2xl hover:text-blue-500 transition-transform transform hover:scale-125" />
          </a>
          <a href="https://in.linkedin.com/company/webmfiya?trk=public_post_feed-actor-name" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FaLinkedin className="text-2xl hover:text-blue-500 transition-transform transform hover:scale-125" />
          </a>
          <a href="https://www.facebook.com/profile.php?id=100094262135444" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FaFacebook className="text-2xl hover:text-blue-500 transition-transform transform hover:scale-125" />
          </a>
        </div>
        <p className="text-sm text-gray-400">&copy; 2024 WebMafiya. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
